import styled, { css } from 'styled-components';
import backgrounds from './backgrounds';
import colors from './colors';
import { actionShadow } from './shadows';
import { StyledButton } from './typings';

const buttonBase = css`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 12px 40px;

  border-width: 0;
  border-radius: 15px;

  @media (max-width: 576px) {
    width: 100%;
  }

  transition: all 0.25s ease-in-out 0s;
`;

export const StyledPrimaryButton = styled(StyledButton)`
  ${buttonBase}

  ${backgrounds.actionPrimary}

  ${actionShadow}

  cursor: pointer;

  color: ${colors.white};

  &:hover {
    color: ${colors.white} !important;
  }
`;

export const StyledSecondaryButton = styled(StyledButton)`
  ${buttonBase}

  ${backgrounds.actionTransparent}

  color: ${colors.action};

  &:hover {
    color: ${colors.darkAction} !important;
  }

  &:active {
    color: ${colors.darkerAction};
  }
`;

const StyledCircleButton = styled(StyledButton)`
  width: 64px;
  height: 64px;
  border: 5px solid rgba(0, 163, 255, 0.1);
  border-radius: 100px;
  color: ${colors.white};

  &:hover {
    border-width: 7px;
    color: ${colors.white} !important;
  }

  &:active {
    border-width: 10px;
  }

  ${backgrounds.actionPrimary}
`;

const buttons = {
  StyledPrimaryButton,
  StyledSecondaryButton,
  StyledCircleButton,
};

export default buttons;
